import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { captureException } from '@sentry/react';
const initFirebase = () => {
    // For Firebase JavaScript SDK v7.20.0 and later, `measurementId` is an optional field
    // Read from window.env (set by Next.js layout at runtime) or fallback to process.env (build-time for legacy Symfony)
    const env = typeof window !== 'undefined' && window.env
        ? window.env
        : {
            FIREBASE_API_KEY: process.env.FIREBASE_API_KEY,
            FIREBASE_AUTH_DOMAIN: process.env.FIREBASE_AUTH_DOMAIN,
            FIREBASE_PROJECT_ID: process.env.FIREBASE_PROJECT_ID,
            FIREBASE_STORAGE_BUCKET: process.env.FIREBASE_STORAGE_BUCKET,
            FIREBASE_MESSAGING_SENDER_ID: process.env.FIREBASE_MESSAGING_SENDER_ID,
            FIREBASE_APP_ID: process.env.FIREBASE_APP_ID,
        };
    const apiKey = env.FIREBASE_API_KEY;
    const authDomain = env.FIREBASE_AUTH_DOMAIN;
    const projectId = env.FIREBASE_PROJECT_ID;
    const storageBucket = env.FIREBASE_STORAGE_BUCKET;
    const messagingSenderId = env.FIREBASE_MESSAGING_SENDER_ID;
    const appId = env.FIREBASE_APP_ID;
    if (!apiKey || !authDomain || !projectId || !storageBucket || !messagingSenderId || !appId) {
        throw new Error('One of the required Firebase config values is missing');
    }
    const firebaseConfig = {
        apiKey,
        authDomain,
        projectId,
        storageBucket,
        messagingSenderId,
        appId,
    };
    if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
    }
    // Attempt to use LOCAL persistence first
    // If it fails (common in Safari due to IndexedDB issues), fall back to SESSION persistence
    // SESSION persistence lasts for the browser tab session and *should* avoid causing IndexedDB-related errors
    firebase
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        .catch(() => {
        firebase
            .auth()
            .setPersistence(firebase.auth.Auth.Persistence.SESSION)
            .catch((e) => {
            captureException(e);
        });
    });
    return firebase.app();
};
export default initFirebase;
